import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ApiLoginPrompt" }
const _hoisted_2 = { class: "body_elements mx-3 my-4 bg-bg text-text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium mt-4"
}, " Email address ", -1 /* HOISTED */)
const _hoisted_4 = { class: "mt-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium mt-2"
}, " Password ", -1 /* HOISTED */)
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = {
  key: 0,
  class: "buttons text-right mx-3 px-4 text-white"
}
const _hoisted_8 = {
  key: 1,
  class: "mt-5 mr-3 sm:mt-4 sm:flex sm:flex-row-reverse"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-left create-account-link my-2 text-xs mx-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-right" }, [
    /*#__PURE__*/_createCommentVNode(" <span>if you do not have an account, or need to reset your password, go to</span "),
    /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-text-faded" }, "Or"),
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-blue-500 hover:text-blue-600 border-b-2 border-blue-500",
      href: "https://polygonjs.com",
      target: "_blank"
    }, "create your account"),
    /*#__PURE__*/_createElementVNode("span", { class: "ml-1 text-text-faded" }, "on Polygonjs")
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorComponent = _resolveComponent("ErrorComponent")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modal, {
      displayed: _ctx.displayed,
      title: "Login",
      ref: "modal",
      size: {x: 400, y: 500},
      resizable: false,
      onClose: _ctx.close
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.errored && _ctx.error_message != null)
            ? (_openBlock(), _createBlock(_component_ErrorComponent, {
                key: 0,
                title: "Login Failed",
                message: _ctx.error_message
              }, null, 8 /* PROPS */, ["message"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            _createElementVNode("form", null, [
              _createCommentVNode(" <label for=\"email\">Email</label>\n\t\t\t\t\t\t<input\n\t\t\t\t\t\t\tid=\"email\"\n\t\t\t\t\t\t\ttype=\"email\"\n\t\t\t\t\t\t\tref=\"email_input\"\n\t\t\t\t\t\t\t@keypress.stop=\"on_keypress\"\n\t\t\t\t\t\t\t@keyup.stop=\"\"\n\t\t\t\t\t\t\t@keydown.stop=\"\"\n\t\t\t\t\t\t/><br /> "),
              _createElementVNode("div", null, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("input", {
                    id: "email",
                    name: "email",
                    type: "email",
                    ref: "email_input",
                    autocomplete: "email",
                    class: "appearance-none block w-full px-3 py-2 bg-black text-white border border-slate-800 rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                    onKeypress: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.on_keypress && _ctx.on_keypress(...args)), ["stop"])),
                    onKeyup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                    onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */)
                ])
              ]),
              _createCommentVNode(" <label for=\"password\">Password</label>\n\t\t\t\t\t\t<input\n\t\t\t\t\t\t\tid=\"password\"\n\t\t\t\t\t\t\ttype=\"password\"\n\t\t\t\t\t\t\tref=\"password_input\"\n\t\t\t\t\t\t\t@keypress.stop=\"on_keypress\"\n\t\t\t\t\t\t\t@keyup.stop=\"\"\n\t\t\t\t\t\t\t@keydown.stop=\"\"\n\t\t\t\t\t\t/> "),
              _createElementVNode("div", null, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("input", {
                    id: "password",
                    name: "password",
                    type: "password",
                    ref: "password_input",
                    autocomplete: "current-password",
                    class: "appearance-none block w-full px-3 py-2 bg-black text-white border border-slate-800 rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                    onKeypress: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.on_keypress && _ctx.on_keypress(...args)), ["stop"])),
                    onKeyup: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                    onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */)
                ])
              ])
            ])
          ]),
          _createCommentVNode("<div class=\"text-right\">\n\t\t\t\t\t<div class=\"buttons\" v-if=\"loading\">\n\t\t\t\t\t\t<font-awesome-icon icon=\"fa-solid fa-recycle\" class=\"animate-spin\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t <div class=\"buttons\" v-else>\n\t\t\t\t\t\t<div class=\"button clear\" @click=\"close\">Cancel</div>\n\t\t\t\t\t\t<div class=\"button success\" id=\"api_login_login\" @click=\"save\">Login</div>\n\t\t\t\t\t</div> \n\t\t\t\t</div>")
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-rotate",
                class: "animate-spin"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", {
                id: "api_login_login",
                type: "button",
                class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-16 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 sm:ml-3 sm:w-auto sm:text-sm cursor-pointer",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, " Login "),
              _createElementVNode("button", {
                id: "dialog-prompt-cancel",
                type: "button",
                class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-bg-medium hover:bg-bg-dark text-base font-medium text-text hover:text-text-light sm:mt-0 sm:w-auto sm:text-sm cursor-pointer",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, " Cancel ")
            ])),
        _hoisted_9
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["displayed", "onClose"])
  ]))
}